module.exports = __webpack_public_path__ + "static/colouring_in_yarra_thumb_2-146a486609a0d43dcc7b5d555ae9bef1.jpg";